<template>
  <div v-if="dbuser" class="container mt-4"  :class="showNewUi && 'new-account'">
    <h3>{{ $t("message.myCards") }}</h3>

    <div v-if="showNewUi">
      <ul v-if="this.savedCards.length" class="list-unstyled card-list">
        <li
            v-for="(card, index) of this.savedCards"
            :key="index"
            class="d-flex justify-content-between py-2 shadow-sm border  mt-2 p-3"
        >
          <div class="payment-card" v-if="card.ElidedPan">
            <span :class="card.CardType | cardName">{{
                card.ElidedPan | newFormatCard
              }}</span>
          </div>
          <div>

            <button  class="btn btn-outline-dark dropdown-toggle white border-white p-0 shadow-none" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="margin-top: -20px; cursor: pointer">
              <span style="font-size: 30px; color: #000000">...</span>
            </button>
            <div class="dropdown-menu">
              <a class="dropdown-item text-danger fw-600" href="#"
                 @click.prevent="selectCard(card.CardIdentifier)">{{ $t("message.remove") }}</a>

            </div>

          </div>
        </li>
      </ul>
      <a href="#" style="color :#55A7FF"  class="fw-600" @click.prevent="fncShowModal()">
        <span  class="material-icons float-left">add</span>
        {{ $t("message.addACard") }}
      </a>
    </div>

    <div v-else>
      <ul v-if="this.savedCards" class="list-unstyled card-list">
        <li
          v-for="(card, index) of this.savedCards"
          :key="index"
          class="d-flex justify-content-between py-2"
        >
          <div class="payment-card" v-if="card.ElidedPan">
            <span :class="card.CardType | cardName">{{
              card.ElidedPan | formatCard
            }}</span>
          </div>
          <div>
            <a
              href="#"
              class="text-danger fw-600"
              @click.prevent="selectCard(card.CardIdentifier)"
              >{{ $t("message.remove") }}</a
            >
          </div>
        </li>
      </ul>
      <a href="#" class=" text-primary fw-600" @click.prevent="fncShowModal()">
        <span class="material-icons float-left">add</span>
        {{ $t("message.addACard") }}
      </a>
    </div>
    <modal v-if="showModal" ref="addModal" @close="closeModal" :fullScreen="showNewUi">
      <template slot="header">
        <div class=" new-fixed-banner mt-3" v-if="showNewUi">
            <span class="material-icons md-36"
                  @click="closeModal">keyboard_arrow_left</span
            >
          <span class="title-text"   @click="closeModal">{{
              $t("message.storeCard")
            }}</span>
        </div>
        <h5 v-else class="modal-title" >{{ $t("message.storeCard") }}</h5>

        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </template>
      <template slot="body">
        <div :class="showNewUi ? 'container' : 'pl-2 pr-2'">
          <card-component
            ref="cardInfo"
            :edit-model="editModel"
            is-user-profile
          />
          <div v-show="error" class="w-100 mt-4">
            <div class="alert alert-danger" role="alert">
              <strong>{{ error }}</strong>
            </div>
          </div>
        </div>
      </template>
      <template slot="footer">
        <div class="w-100 d-flex justify-content-between mb-2">
          <button
            type="button"
            class="btn btn-lg btn-cancel"
            @click="error = ''"
            data-dismiss="modal"
          >
            {{ $t("message.cancel") }}
          </button>
          <button
            :disabled="loading"
            type="button"
            class="btn btn-lg btn-primary w-75 d-flex justify-content-between shadow"
            @click="addCard"
            :style="getButtonStyles"
          >
            {{ $t("message.addCard") }}
            <span v-show="loading">
              <i class="spin ml-4" />
            </span>
          </button>
        </div>
      </template>
    </modal>
    <confirm
      v-if="showConfirm"
      ref="deleteConfirm"
      :proccessing="deleting"
      @confirmed="deleteCard"
      @close="closeConfirm"
    >
      <template slot="body">
        <p class="p-3">{{ $t("message.areYouSureDeleteCard") }}</p>
        <div v-show="cardError" class="w-100 mt-4">
          <div class="alert alert-danger" role="alert">
            <strong>{{ cardError }}</strong>
          </div>
        </div>
      </template>
    </confirm>
  </div>
</template>

<style scoped>
.btn.btn:hover {
  background-color: #ffffff;
}

</style>

<script>
import modal from "./../modal";
import confirm from "../confirm";
import shared from "../../sharedscripts/user/cards.js";
import CardComponent from "../shared/CardComponent";
import { mapGetters } from "vuex";
export default {
  components: {
    modal,
    confirm,
    CardComponent,
  },
  filters: {
    ...shared.filters,
  },

  data() {
    return {
      showModal: false,
      showConfirm: false,
      editModel: {
        CardNumber: "",
        CVV: "",
        ExpireDate: "",
      },
      cardType: "master",
      loading: false,
      error: "",
      selectedCard: "",
      deleting: false,
      cardError: "",
      savedCards: [],
    };
  },
  mounted() {
    shared.mounted(this);
  },
  computed: {
    ...shared.computed,
    ...mapGetters(["desktopStyles", "dbuser" , "viewConfig"]),
    showNewUi(){
      return this.viewConfig.IsNewUi;
    },
    getButtonStyles() {
      let styles = []
      if(this.showNewUi){
        styles.push({
          borderRadius : '5px !important'
        })
      }
      styles.push(this.desktopStyles.btn)
      return styles
    }

  },
  methods: {
    ...shared.methods,
  },
};
</script>
